import useActiveSocialProfile from '@/hooks/user/useActiveSocialProfile';
//hooks
import useAcl from '@/utils/hooks/user/useAcl';

import PropTypes from 'prop-types';

// Lib
import { aclFeatures } from '@/lib/acl/aclFeatures';
import { POST, STORY } from '@/lib/posts/postTypes';
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    THREADS,
    TIKTOK_BUSINESS,
    TWITTER,
    X,
    YOUTUBE
} from '@/lib/socialProfile';

// Components
import Icon from '@/components/base/Icon';
import { DefaultPreview } from '@/components/composite/MediaViewer/PostPreview/PreviewDefault';
import { PreviewLinkedin } from '@/components/composite/MediaViewer/PostPreview/PreviewLinkedin';
import { PreviewPinterest } from '@/components/composite/MediaViewer/PostPreview/PreviewPinterest';
import { PreviewThreads } from '@/components/composite/MediaViewer/PostPreview/PreviewThreads';
import { PreviewTiktokBusiness } from '@/components/composite/MediaViewer/PostPreview/PreviewTiktokBusiness';
import { PreviewTwitter } from '@/components/composite/MediaViewer/PostPreview/PreviewTwitter';
import { PreviewX } from '@/components/composite/MediaViewer/PostPreview/PreviewX';
import { PreviewYoutube } from '@/components/composite/MediaViewer/PostPreview/PreviewYoutube';

const getPreview = (network, props) => {
    switch (network) {
        case FACEBOOK:
        case INSTAGRAM:
            return <DefaultPreview network={network} {...props} />;
        case LINKEDIN:
            return <PreviewLinkedin {...props} />;
        case PINTEREST:
            return <PreviewPinterest {...props} />;
        case TWITTER:
            return <PreviewTwitter {...props} />;
        case X:
            return <PreviewX {...props} />;
        case THREADS:
            return <PreviewThreads {...props} />;
        case TIKTOK_BUSINESS:
            return <PreviewTiktokBusiness {...props} />;
        case YOUTUBE:
            return <PreviewYoutube {...props} />;
    }
};

const MediaViewerPreview = ({
    post,
    postType,
    isLoading,
    socialProfile,
    openInNewTab = true,
    remoteMedia = false,
    repostEmail
}) => {
    const { hasAcl } = useAcl();
    const { activeSocialProfile } = useActiveSocialProfile();
    const currentSocialProfile = socialProfile ?? activeSocialProfile;
    return (
        <div className="relative">
            {!isLoading &&
            post?.promoted_post &&
            hasAcl(aclFeatures.analytic.promoted_post.read) ? (
                <span className="absolute left-2.5 top-2.5 z-10 flex h-5 w-5 items-center justify-center rounded-full bg-icoBlue text-sm leading-none text-white lg:h-6 lg:w-6 lg:text-base">
                    <Icon icon="paid-data" className="align-bottom" />
                </span>
            ) : null}
            {getPreview(currentSocialProfile?.social_network_type, {
                post,
                postType,
                isLoading,
                openInNewTab,
                remoteMedia,
                repostEmail
            })}
        </div>
    );
};

MediaViewerPreview.propTypes = {
    post: PropTypes.object,
    postType: PropTypes.oneOf([POST, STORY]),
    isLoading: PropTypes.bool,
    socialProfile: PropTypes.object,
    remoteMedia: PropTypes.bool
};

export { getPreview, MediaViewerPreview };
